import type { TPreviewStatusBarColor } from '../../features/generator/generatorState'

export const PreviewStatusBar = ({
	color,
}: {
	color: TPreviewStatusBarColor
}) => {
	return (
		<svg
			width={260}
			height={30}
			viewBox="10 8 260 30"
			className="absolute left-0 top-0 z-[1]"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="battery-and-its-mask">
				<mask
					id="mask1_188_3879"
					style={{
						maskType: 'luminance',
					}}
					maskUnits="userSpaceOnUse"
					x={231}
					y={22}
					width={20}
					height={10}
				>
					<g id="clip-path">
						<path
							id="Rectangle 2345"
							d="M250.484 22.596h-19.149v9.04h19.149z"
							fill="#fff"
						/>
					</g>
				</mask>
				<g id="battery" mask="url(#mask1_188_3879)">
					<g
						id="Group 1721"
						fill={color}
						className="transition-colors duration-200"
					>
						<path
							id="Path 2795"
							d="M246.107 31.636h-12.036a2.7 2.7 0 0 1-1.933-.828 2.88 2.88 0 0 1-.803-1.997v-3.39c.001-.749.29-1.467.803-1.996a2.7 2.7 0 0 1 1.933-.829h12.038c.725.002 1.42.3 1.932.83.513.529.801 1.247.802 1.995v3.39a2.88 2.88 0 0 1-.802 1.997 2.7 2.7 0 0 1-1.934.828m-12.036-8.475c-.58 0-1.137.24-1.547.663s-.641.998-.642 1.597v3.39c.001.6.232 1.174.642 1.598.41.423.967.662 1.547.662h12.038c.58 0 1.137-.239 1.547-.662s.641-.998.641-1.598v-3.39c0-.6-.231-1.174-.642-1.598a2.15 2.15 0 0 0-1.548-.662z"
						/>
						<path
							id="Path 2796"
							d="M234.072 23.726h7.66c.435 0 .852.179 1.16.497.308.317.481.749.481 1.198v3.39c0 .449-.173.88-.481 1.198a1.62 1.62 0 0 1-1.16.497h-7.66a1.62 1.62 0 0 1-1.161-.497 1.72 1.72 0 0 1-.481-1.198v-3.39c0-.45.173-.88.481-1.198a1.62 1.62 0 0 1 1.161-.497"
						/>
						<path
							id="Path 2797"
							d="M249.39 28.246v-2.26a1.06 1.06 0 0 1 .793.32 1.13 1.13 0 0 1 .331.81 1.16 1.16 0 0 1-.331.81 1.07 1.07 0 0 1-.793.32"
						/>
					</g>
				</g>
			</g>
			<g id="Group 1723">
				<g id="Clip path group_2">
					<mask
						id="mask2_188_3879"
						style={{
							maskType: 'luminance',
						}}
						maskUnits="userSpaceOnUse"
						x={210}
						y={22}
						width={13}
						height={10}
					>
						<g id="clip-path-2">
							<path
								id="Rectangle 551"
								d="M222.747 22.596H210.71v9.04h12.037z"
								fill="#fff"
							/>
						</g>
					</mask>
					<g id="signal" mask="url(#mask2_188_3879)">
						<g
							id="Group 1210"
							fill={color}
							className="transition-colors duration-200"
						>
							<path
								id="Path 1848"
								opacity={0.294}
								d="M221.325 22.596h.657a.75.75 0 0 1 .542.232.8.8 0 0 1 .224.56v7.458q0 .158-.058.303a.78.78 0 0 1-.415.428.8.8 0 0 1-.293.06h-.657a.75.75 0 0 1-.543-.232.8.8 0 0 1-.223-.56v-7.457a.79.79 0 0 1 .472-.731.8.8 0 0 1 .294-.06"
							/>
							<path
								id="Path 1849"
								opacity={0.294}
								d="M218.042 24.856h.656a.75.75 0 0 1 .542.232q.108.11.166.256a.8.8 0 0 1 .059.303v5.198a.8.8 0 0 1-.473.731.8.8 0 0 1-.294.06h-.656a.75.75 0 0 1-.542-.232.8.8 0 0 1-.225-.56v-5.197q0-.156.058-.302a.8.8 0 0 1 .415-.429.8.8 0 0 1 .294-.06"
							/>
							<path
								id="Path 1850"
								d="M214.759 27.116h.657a.75.75 0 0 1 .542.232.8.8 0 0 1 .224.56v2.937a.8.8 0 0 1-.224.56.76.76 0 0 1-.542.231h-.657a.75.75 0 0 1-.542-.231.8.8 0 0 1-.224-.56v-2.938q0-.157.058-.302a.76.76 0 0 1 .708-.488"
							/>
							<path
								id="Path 1851"
								d="M211.476 28.247h.657a.74.74 0 0 1 .542.231.8.8 0 0 1 .224.56v1.811a.8.8 0 0 1-.224.56.77.77 0 0 1-.542.231h-.657a.74.74 0 0 1-.543-.233.8.8 0 0 1-.223-.561v-1.811a.8.8 0 0 1 .225-.558.75.75 0 0 1 .541-.23"
							/>
						</g>
					</g>
				</g>
			</g>
			<path
				id="time"
				d="M29.982 30.456a.4.4 0 0 1-.295-.108.4.4 0 0 1-.109-.285q0-.187.109-.285a.43.43 0 0 1 .295-.098h1.243v-5.394h.473l-1.44.924a.43.43 0 0 1-.266.078.4.4 0 0 1-.207-.098.44.44 0 0 1-.118-.206.4.4 0 0 1 .01-.236.4.4 0 0 1 .197-.206l1.36-.885q.15-.087.276-.137a.7.7 0 0 1 .267-.059q.147 0 .256.088.108.09.108.285v5.846h1.144q.197 0 .296.098.108.098.108.285a.4.4 0 0 1-.108.295q-.099.098-.296.098zm7.44.089q-.789 0-1.35-.226a1.9 1.9 0 0 1-.858-.659q-.296-.432-.296-1.05 0-.483.197-.856.207-.382.562-.619.356-.235.818-.294v.157q-.65-.138-1.035-.6a1.73 1.73 0 0 1-.374-1.11q0-.58.285-.992a1.8 1.8 0 0 1 .819-.639q.522-.215 1.232-.216.72 0 1.242.216.523.217.809.64.285.412.286.991 0 .423-.178.786a1.54 1.54 0 0 1-.483.6 1.8 1.8 0 0 1-.73.324v-.157q.69.097 1.125.58.433.471.433 1.188 0 .62-.305 1.051-.295.432-.858.659-.552.225-1.34.226m0-.737q.81 0 1.223-.315.414-.314.414-.933 0-.63-.414-.933-.414-.305-1.223-.305-.799 0-1.222.305-.415.304-.415.933 0 .62.415.933.423.315 1.222.315m0-3.233q.464 0 .789-.137.325-.148.503-.423.177-.275.177-.648 0-.56-.394-.874-.385-.315-1.075-.315t-1.075.315q-.384.314-.384.874 0 .57.384.894.385.315 1.075.314m4.205 3.92a.576.576 0 0 1-.591-.589.54.54 0 0 1 .167-.413.6.6 0 0 1 .424-.157q.276 0 .424.157a.56.56 0 0 1 .158.413.6.6 0 0 1-.158.422q-.148.167-.424.167m0-3.703a.6.6 0 0 1-.424-.158.57.57 0 0 1-.167-.422.54.54 0 0 1 .167-.413.58.58 0 0 1 .424-.167q.276 0 .424.167a.56.56 0 0 1 .158.413.6.6 0 0 1-.158.422q-.148.158-.424.158m5.358 3.733q-.218 0-.336-.118-.117-.118-.118-.344v-1.051h-2.74a.6.6 0 0 1-.356-.098q-.128-.099-.128-.305 0-.118.06-.246.059-.128.206-.343l2.928-4.254a.9.9 0 0 1 .227-.226.54.54 0 0 1 .286-.079q.177 0 .296.118.128.108.128.344v4.313h.67q.218 0 .326.098t.108.285q0 .196-.108.295t-.325.098h-.67v1.051q0 .225-.12.344-.117.118-.334.118m-.454-2.29v-3.634h.247l-2.662 3.88v-.245zm5.438 2.31q-.552 0-1.114-.158a3.3 3.3 0 0 1-1.005-.5.5.5 0 0 1-.178-.207.45.45 0 0 1-.01-.246.4.4 0 0 1 .119-.196.32.32 0 0 1 .207-.098.43.43 0 0 1 .266.078q.395.276.818.413.425.128.888.128.464 0 .798-.177.336-.177.513-.492.187-.315.187-.736 0-.649-.384-1.061-.385-.413-1.045-.413-.405 0-.75.147a1.7 1.7 0 0 0-.63.472.6.6 0 0 1-.178.138.43.43 0 0 1-.227.058q-.187 0-.286-.098a.4.4 0 0 1-.098-.285v-3.37q0-.195.108-.304a.4.4 0 0 1 .306-.108h3.322a.44.44 0 0 1 .306.098q.108.098.108.285a.4.4 0 0 1-.108.295.44.44 0 0 1-.306.098h-2.84v2.623h-.255q.266-.393.71-.609.453-.216.995-.216.66 0 1.134.285.483.275.75.776.265.49.265 1.15 0 .648-.295 1.159-.286.501-.819.786t-1.271.285"
				fill={color}
				className="transition-colors duration-200"
			/>
		</svg>
	)
}
